export const SET_INDIGO_PINK_THEME = 'SET_INDIGO_PINK_THEME'
export const SET_CYAN_AMBER_THEME = 'SET_CYAN_AMBER_THEME'
export const SET_RED_BROWN_THEME = 'SET_RED_BROWN_THEME'
export const SET_LIGHT_GREEN_BLUE_THEME = 'SET_LIGHT_GREEN_BLUE_THEME'
export const SET_PERSO_THEME = 'SET_PERSO_THEME'